import React, { useEffect, useState } from "react";
import logodark from "../motos_lp/assets/images/Easy-MembrLogo.png";
import { NavbarBrand, } from "reactstrap";
import { Link } from "react-router-dom";
import { MDBBtn, MDBIcon } from "mdb-react-ui-kit";
function Privacy() {
  const [imageLoaded, setimageLoaded] = useState(true);
  const [logourl, setlogourl] = useState(localStorage.getItem("loggedUserInfo") ? (JSON.parse(localStorage.getItem("loggedUserInfo")).gymlogoUrl || logodark) : logodark);
  return (
    <>
      <div className="mb-10">
        <nav id="navbar" className="navbar navbar-expand-lg fixed-top sticky align-items-center justify-content-center">


          <NavbarBrand to="/">
            {imageLoaded ? (
              <>
                <div className="d-flex align-items-center position-relative">
                  <img src={logourl} alt="Logo" className="newLogo" onLoad={() => setimageLoaded(true)} onError={() => setimageLoaded(false)} />
                  <div className="text-dark fs-6 ByZencruzText" >By Zencruz</div>
                </div>
              </>
            ) : (
              <>
                <div className="d-flex align-items-center position-relative">
                  <img src={logodark} alt="Default Logo" className="newLogo" />
                  <div className="text-dark fs-6 ByZencruzText" >By Zencruz</div>
                </div>
              </>

            )}
          </NavbarBrand>
          <div className="back-to-home">
            <Link to={-1}>
              <MDBBtn>
                <MDBIcon fas icon="arrow-left" />
              </MDBBtn>
            </Link>
          </div>
        </nav>
      </div>
      <h3 className="py-4 container font">Privacy Policy:</h3>
      <div className="container font" >

        <section>
          <h5>Collection of Personal Information:</h5>
          <p className="fs-12">When you use EasyMembr, we may collect certain personal information from you, such as your name, email address, and contact details. This information is necessary for the proper functioning of the software and to provide you with the requested services.
          </p>
        </section>

        <section>
          <h5>Use of Personal Information:</h5>
          <p className="fs-12">The personal information collected will be used for the purposes of managing your gym administration activities, providing customer support, and improving the functionality of EasyMembr. We will not sell, rent, or disclose your personal information to any third parties without your consent, except as required by law.
          </p>
        </section>

        <section>
          <h5>Data Security:</h5>
          <p className="fs-12">We take appropriate measures to protect your personal information from unauthorized access, loss, or disclosure. However, please note that no data transmission over the internet or storage system can be guaranteed to be 100% secure.
          </p>
        </section>

        <section>
          <h5>Cookies and Tracking Technologies:</h5>
          <p className="fs-12">EasyMembr may use cookies and similar tracking technologies to enhance your user experience and collect usage information. These technologies may collect information such as your IP address, browser type, and operating system. You can choose to disable cookies in your browser settings, but this may affect certain functionalities of the software.
          </p>
        </section>

        <section>
          <h5>Third-Party Links:</h5>
          <p className="fs-12">EasyMembr may contain links to third-party websites or services. We are not responsible for the privacy practices or content of these third-party sites. We encourage you to review the privacy policies of these sites before providing any personal information.
          </p>
        </section>

        <section>
          <h5>Data Retention:</h5>
          <p className="fs-12">We will retain your personal information for as long as necessary to fulfill the purposes for which it was collected, or as required by law.
          </p>
        </section>

        <section>
          <h5>Changes to the Privacy Policy:</h5>
          <p className="fs-12">We reserve the right to update or modify this Privacy Policy at any time. Any changes will be effective upon posting the revised Privacy Policy on the EasyMembr website. It is your responsibility to review this Privacy Policy periodically.
          </p>
        </section>
        <p className="fs-12">
          <h5>Please note:</h5>Privacy Policy is a general example and may not cover all specific details or legal requirements. It is recommended to consult with a legal professional to create a comprehensive and tailored Privacy Policy for your gym's specific needs and jurisdiction.</p>
      </div>
        </>
        )
    }

export default Privacy;
